import React from 'react'
import { Container, Row, Col, Table } from 'react-bootstrap'
import "../spot_styles/spotlower.css";

export default function TradeTable() {

  const dummyData = [
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
    {
      price: "$16,789",
      amount: 0.44,
      time: "11:44:02"
    },
  ]

  return (
    <Container fluid className='p-0 m-0'>
      <Row>
      <Col className="lower_spot_left_left">
          <div className="lower_head mt-3">
            <h6>Trade </h6>
          </div>
          <div className="lower_spot_table_left_right">
            <Table borderless>
              <thead>
                <tr>
                  <td>Price (USDT)</td>
                  <td className='text-end'>Amount (BTC)</td>
                  <td className='text-end'>Time</td>
                </tr>
              </thead>
              <tbody>
                {
                  dummyData.map((item) => {
                    return(
                      <>
                        <tr>
                          <td className="lower_order_fst_td">{item.price}</td>
                          <td className="lower_order_other_td text-end">{item.amount}</td>
                          <td className="lower_order_other_td text-end">{item.time}</td>
                        </tr>
                      </>
                    )
                  })
                }
                {/* <tr>
                  <td className="lower_order_fst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_fst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_fst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_fst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_fst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_fst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr>
                <tr>
                  <td className="lower_order_lowfst_td">$16,789.00</td>
                  <td className="lower_order_other_td text-end">0.046</td>
                  <td className="lower_order_other_td text-end">09: 11: 44</td>
                </tr> */}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
